import _get from 'lodash/get';

import { FilterGroup, Operator } from 'pages/RolesAndPermissions/typings';

function transformToApiFilter(filterGroups: FilterGroup[], outerOperator: Operator) {
  if (!filterGroups.length) {
    return null;
  }

  const innerStatements = filterGroups.map(group => ({
    [group.operator]: group.filters.map(statement => {
      const { comparison, value, type } = statement;
      const objectKey = _get(statement, 'field.objectKey');

      const fieldType = _get(statement, ['field', 'type'], 'unknown');

      return {
        field: objectKey,
        comparison,
        value: transformValue(value, fieldType),
        type,
      };
    }),
  }));

  return { [outerOperator]: innerStatements };
}

function transformValue(value: any, type: any) {
  if (value === '') {
    // NOTE(rbickham11):
    // Values are initialized as empty strings in the UI,
    // and we should not include an empty string in the API filter.
    // It is possible that we have values like `false`, so we should
    // not just do a falsy check here
    return undefined;
  }

  if (type === 'boolean') {
    if (value === 'true') {
      return true;
    }
    if (value === 'false') {
      return false;
    }
  }

  if (type === 'number' && typeof value === 'string') {
    return Number(value);
  }

  return value;
}

export default transformToApiFilter;
